module.exports = __webpack_public_path__ + "img/Kosovo.5a65f9e6.png";